// NAME-SPACE of modules
import { ModulesMap } from '../modulesMaps'

// ENDPOINTS MODULES
import landDocumentsEndpointConfig from './landDocumentsEndpointConfig'
import equipmentRegistrationsEndpointConfig from './equipmentRegistrationsEndpointConfig'
import equipmentFactplacesEndpointConfig from './equipmentFactplacesEndpointConfig'
import incidentCommentsEndpointConfig from './incidentsCommentsEndpointConfig'
import incidentsEndpointConfig from './incidentsEndpointConfig'
import incidentsMyWorksToAdministrateIncidentsEndpointConfig from './incidentsMyWorksToAdministrateIncidentsEndpointConfig'
import regulationsStagesPlanWorksQualitiControlsEndpointConfig from './regulationsStagesPlanWorksQualitiControlsEdpointConfig'
import regulationsStagesPlanWorksServicePaymentsEndpointConfig from './regulationsStagesPlanWorksServicePaymentsEndpointConfig'
import regulationsStagesPlanWorksStaffPaymentsEndpointConfig from './regulationsStagesPlanWorksStaffPaymentsEndpointConfig'
import regulationsStagesPlanWorksStaffGroupsEndpointConfig from './regulationsStagesPlanWorksStaffGroupsEndpointConfig'
import regulationsStagesPlanWorksProductsEndpointConfig from './regulationsStagesPlanWorksProductsEndpointConfig'
import regulationsStagesPlanWorksMaterialsEndpointConfig from './regulationsStagesPlanWorksMaterialsEndpointConfig'
import trips from './tripsEndpointConfig'
import positionDevices from './positionDevicesEndpointConfig'
import worksServicePaymentRateNormsEndpointConfig from './worksServicePaymentRateNormsEndpointConfig'
import worksMaterialProductionRateNormsEndpointConfig from './worksMaterialProductionRateNormsEndpointConfig'
import staffAndMachineryCards from './staffAndMachineryCardsConfig'
import auth from './authEndpointConfig'
import cacheEndpointConfig from './cacheEndpointConfig'
import user from './userEndpointConfig'
import company from './companyEndpointConfig'
import companyFuelSettings from './companyFuelSettingsEndpointConfig'
import presets from './presetsEndpointConfig'
import machines from './machinesEndpointConfig'
import equipment from './equipmentEndpointConfig'
import infrastructureTypes from './infrastructureTypesEndpointConfig'
import partners from './partnersEndpointConfig'
import aggregateCards from './aggregateCardsEndpointConfig'
import infrastructureTags from './infrastructureTagsEndpointConfig'
import gpsSource from './gpsSourcesEndpointConfig'
import identityCards from './identityCardsEndpointConfig'
import identityMounts from './identityMountsEndpointConfig'
import machineBrigade from './machineBrigadesEndpointConfig'
import machinePhotos from './machinePhotosEndpointConfig'
import machineTransfers from './machineTransfersEndpointConfig'
import fuel from './fuelEndpointConfig'
import fuelStations from './fuelStationsEndpointConfig'
import fuelStationEvents from './fuelStationEventsEndpointConfig'
import fuelStationRawEvents from './fuelStationRawEventsEndpointConfig'
import fuelStationGuns from './fuelStationGunsEndpointConfig'
import worksMaterialConsumptionRateNorms from './worksMaterialConsumptionRateNormsEndpointConfig'
import worksProductivityNorms from './worksProductivityNormsEndpointConfig'
import worksQualityNorms from './worksQualityNormsEndpointConfig'
import regulationsApplicationArea from './regulationsApplicationAreaEndpointConfig'
import worksStaffPaymentRatesNorms from './worksStaffPaymentRatesNormsEndpointConfig'
import crops from './cropsEndpointConfig'
import positionsMachines from './positionsMachinesEndpointConfig'
import events from './eventsEndpointConfig'
import infrastructurePhotos from './infrastructurePhotosEndpointConfig'
import equipmentPhotosEndpointConfig from './equipmentPhotosEndpointConfig'
import regulationsMetricsEndpointConfig from './regulationsMetricsEndpointConfig'
import regulationsStagesEndpointConfig from './regulationsStagesEndpointConfig'
import regulationsTargetProductsEndpointConfig from './regulationsTargetProductsEndpointConfig'
import regulationsStagesPlanWorksEndpointConfig from './regulationsStagesPlanWorks.js'
import mapsEndpointConfig from './mapsEndpointConfig'
import businessProcessesEndpointConfig from './businessProcessesEndpointConfig'
import regulationBaseFinanceAttributionEndpointConfig from './regulationBaseFinanceAttributionEndpointConfig'
import notificationsEndpointConfig from './notificationsEndpointConfig'
import regulationPlanWorkFinanceAttributionEndpointConfig from './regulationPlanWorkFinanceAttributionEndpointConfig'
import reportFinanceByCategoriesEndpointConfig from './reportFinanceByCategoriesEndpointConfig'
import reportFinanceByDestinationEndpointConfig from './reportFinanceByDestinationEndpointConfig'
import reportFinanceByWorkTypeEndpointConfig from './reportFinanceByWorkTypeEndpointConfig'
import reportFinanceEfficiencyEndpointConfig from './reportFinanceEfficiencyEndpointConfig'
import reportFinanceProductsEndpointConfig from './reportFinanceProductsEndpointConfig'
import reportStagesProgressEndpointConfig from './reportStagesProgressEndpointConfig'
import reportStagesProgressWithWorksEndpointConfig from './reportStagesProgressWithWorksEndpointConfig'
import reportsEndpointConfig from './reportsEndpointConfig'
import reportsDoneWorksCostsEndpointConfig from './reportsDoneWorksCostsEndpointConfig'
import reportsQualityControlsEndpointConfig from './reportsQualityControlsEndpointConfig'
import reportsDoneWorksEndpointConfig from './reportsDoneWorksEndpointConfig'
import reportsServicePaymentsEndpointConfig from './reportsServicePaymentsEndpointConfig'
import reportsStaffPaymentsEndpointConfig from './reportsStaffPaymentsEndpointConfig'
import reportsFinanceByMaterialsCategoriesEndpointConfig from './reportsFinanceByMaterialsCategoriesEndpointConfig'
import reportsFinanceByRolesEndpointConfig from './reportsFinanceByRolesEndpointConfig'
import reportsFinanceByServicesEndpointConfig from './reportsFinanceByServicesEndpointConfig'
import reportsFinanceByWorkCategoriesEndpointConfig from './reportsFinanceByWorkCategoriesEndpointConfig'
import doneWorksBrigadeEndpointConfig from './doneWorksBrigadeEndpointConfig'
import doneWorksCalculationVolumeMetricsEndpointConfig from './doneWorksCalculationVolumeMetricsEndpointConfig'
import doneWorksDocumentsEndpointConfig from './doneWorksDocumentsEndpointConfig'
import doneWorksFinanceAttributionEndpointConfig from './doneWorksFinanceAttributionEndpointConfig'
import doneWorksLinksEndpointConfig from './doneWorksLinksEndpointConfig'
import doneWorksMeasuresEndpointConfig from './doneWorksMeasuresEndpointConfig'
import doneWorksPhotosEndpointConfig from './doneWorksPhotosEndpointConfig'
import doneWorksEndpointConfig from './doneWorksEndpointConfig'
import regulationsStagesPlanWorksRecomendedMachinesEndpointConfig from './regulationsStagesPlanWorksRecomendedMachinesEndpointConfig'
import regulationsStagesPlanWorksRecomendedEquipmentEndpointConfig from './regulationsStagesPlanWorksRecomendedEquipmentEndpointConfig'
import regulationsStagesPlanWorksRecomendedCounterpartiesEndpointConfig from './regulationsStagesPlanWorksRecomendedCounterpartiesEndpointConfig'
import regulationsStagesPlanWorksRecomendedStaffEndpointConfig from './regulationsStagesPlanWorksRecomendedStaffEndpointConfig'
import regulationsFinanceProductivityEndpointConfig from './regulationsFinanceProductivityEndpointConfig'
import reportsReportingEndpointConfig from './reportsReportingEndpointConfig'

import regulationStageFinanceAttributionEndpointConfig from './regulationStageFinanceAttributionEndpointConfig'
import doneWorksManufacturedMaterialsEndpointConfig from './doneWorksManufacturedMaterialsEndpointConfig'
import doneWorksOperationalMaterialsEndpointConfig from './doneWorksOperationalMaterialsEndpointConfig'
import doneWorksServices from './doneWorksServicesEndpointConfig'
import doneWorksCalculationMetricsMetricsEndpointConfig from './doneWorksCalculationMaterialsMetricsEndpointConfig'
import doneWorksInProgressFieldWorksEndpointConfig from './doneWorksInProgressFieldWorksEndpointConfig'
import businessProcessesActivePlanWorksEndpointConfig from './businessProcessesActivePlanWorksEndpointConfig'
import rulesBreakingEndpointConfig from './rulesBreakingEndpointConfig'
import doneWorksControlMetricEndpointConfig from './doneWorksControlMetricEndpointConfig'
import workOrdersEndpointConfig from './workOrdersEndpointConfig'
import workOrdersMaterialsEndpointConfig from './workOrdersMaterialsEndpointConfig'
import workOrdersProductsEndpointConfig from './workOrdersProductsEndpointConfig'
import doneWorksDoneFieldWorksConfig from './doneWorksDoneFieldWorksConfig'
import weighingCombinerTicketsEndpointConfig from './weighingCombinerTicketsEndpointConfig'
import doneWorksMyWorksToAdministrateEndpointConfig from './doneWorksMyWorksToAdministrateEndpointConfig'
import doneWorksMyWorksToControlEndpointConfig from './doneWorksMyWorksToControlEndpointConfig'
import doneWorksMyWorksToDoEndpointConfig from './doneWorksMyWorksToDoEndpointConfig'
import orderGeneratorsFieldsWorksEndpointConfig from './orderGeneratorsFieldsWorksEndpointConfig'
import orderGeneratorsFieldsWorksPlanWorksEndpointConfig from './orderGeneratorsFieldsWorksPlanWorksEndpointConfig'
import orderGeneratorsFieldsWorksQualityControlsEndpointConfig from './orderGeneratorsFieldsWorksQualityControlsEndpointConfig'
import orderGeneratorsFieldsWorksProductsEndpointConfig from './orderGeneratorsFieldsWorksProductsEndpointConfig'
import orderGeneratorsFieldsWorksStaffPaymentsEndpointConfig from './orderGeneratorsFieldsWorksStaffPaymentsEndpointConfig'
import orderGeneratorsFieldsWorksMaterialsEndpointConfig from './orderGeneratorsFieldsWorksMaterialsEndpointConfig'
import orderGeneratorsFieldsWorksExecutorsBrigadesEndpointConfig from './orderGeneratorsFieldsWorksExecutorsBrigadesEndpointConfig'
import orderGeneratorsFieldsWorksExecutorsEndpointConfig from './orderGeneratorsFieldsWorksExecutorsEndpointConfig'
import orderGeneratorsFieldsWorksServicesEndpointConfig from './orderGeneratorsFieldsWorksServicesEndpointConfig'
import logisticRoutesEndpointConfig from './logisticRoutesEndpointConfig'
import logisticRoutesGeoZonesEndpointConfig from './logisticRoutesGeoZonesEndpointConfig'
import reportDeviceMountsEndpointConfig from './reportDeviceMountsEndpointConfig'
import doneWorksAllFieldWorksEndpointConfig from './doneWorksAllFieldWorksEndpointConfig'
import doneWorksAllLogisticWorksEndpointConfig from './doneWorksAllLogisticWorksEndpointConfig'
import doneWorksAllHandMadeWorksEndpointConfig from './doneWorksAllHandMadeWorksEndpointConfig'
import regulationsAllPlanWorksEndpointConfig from './regulationsAllPlanWorksEndpointConfig'
import cargosEndpointConfig from './cargosEndpointConfig'
import cargoItemsEndpointConfig from './cargoItemsEndpointConfig'
import cargoTagsEndpointConfig from './cargoTagsEndpointConfig'
import apiUsagesEndpointConfig from './apiUsagesEndpointConfig'
import landsEndpointConfig from './landsEndpointConfig'
import equipmentDocumentsEndpointConfig from './equipmentDocumentsEndpointConfig'
import equipmentPledgesEndpointConfig from './equipmentPledgesEndpointConfig'
import landsCadastralCasesEndpointConfig from './landsCadastralCasesEndpointConfig'
import customGeoZonesEndpointConfig from './customGeoZonesEndpointConfig'
import customGeoZonesCategoriesEndpointConfig from './customGeoZonesCategoriesEndpointConfig'
import regulationsStaffRolesInfoEndpointConfig from './regulationsStaffRolesInfoEndpointConfig'
import businessProcessBaseExecutorsEndpointConfig from './businessProcessBaseExecutorsEndpointConfig'

export default {
	[ModulesMap.LAND_DOCUMENTS]: landDocumentsEndpointConfig,
	[ModulesMap.EQUIPMENT_REGISTRATIONS]: equipmentRegistrationsEndpointConfig,
	[ModulesMap.EQUIPMENT_FACTPLACES]: equipmentFactplacesEndpointConfig,
	[ModulesMap.INCIDENT_COMMENTS]: incidentCommentsEndpointConfig,
	[ModulesMap.INCIDENTS]: incidentsEndpointConfig,
	[ModulesMap.INCIDENTS_MY_WORKS_TO_ADMINISTRATE_INCIDENTS]: incidentsMyWorksToAdministrateIncidentsEndpointConfig,
	[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS]: regulationsStagesPlanWorksQualitiControlsEndpointConfig,
	[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS]: regulationsStagesPlanWorksServicePaymentsEndpointConfig,
	[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS]: regulationsStagesPlanWorksStaffPaymentsEndpointConfig,
	[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS]: regulationsStagesPlanWorksStaffGroupsEndpointConfig,
	[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS]: regulationsStagesPlanWorksProductsEndpointConfig,
	[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS]: regulationsStagesPlanWorksMaterialsEndpointConfig,
	[ModulesMap.TRIPS]: trips,
	[ModulesMap.POSITION_DEVICES]: positionDevices,
	[ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS]: worksServicePaymentRateNormsEndpointConfig,
	[ModulesMap.WORKS_MATERIAL_PRODUCTION_RATE_NORMS]: worksMaterialProductionRateNormsEndpointConfig,
	[ModulesMap.STAFF_AND_MACHINERY_CARDS]: staffAndMachineryCards,
	[ModulesMap.CACHE]: cacheEndpointConfig,
	[ModulesMap.USER]: user,
	[ModulesMap.COMPANY]: company,
	[ModulesMap.COMPANY_FUEL_SETTINGS]: companyFuelSettings,
	[ModulesMap.AUTH]: auth,
	[ModulesMap.PRESETS]: presets,
	[ModulesMap.MACHINES]: machines,
	[ModulesMap.EQUIPMENT]: equipment,
	[ModulesMap.INFRASTRUCTURE_TYPES]: infrastructureTypes,
	[ModulesMap.PARTNERS]: partners,
	[ModulesMap.AGGREGATE_CARDS]: aggregateCards,
	[ModulesMap.INFRASTRUCTURE_TAGS]: infrastructureTags,
	[ModulesMap.GPS_SOURCES]: gpsSource,
	[ModulesMap.IDENTITY_CARDS]: identityCards,
	[ModulesMap.IDENTITY_MOUNTS]: identityMounts,
	[ModulesMap.MACHINE_BRIGADE]: machineBrigade,
	[ModulesMap.MACHINE_PHOTOS]: machinePhotos,
	[ModulesMap.MACHINE_TRANSFERS]: machineTransfers,
	[ModulesMap.FUEL]: fuel,
	[ModulesMap.FUEL_STATIONS]: fuelStations,
	[ModulesMap.FUEL_STATION_EVENTS]: fuelStationEvents,
	[ModulesMap.FUEL_STATION_RAW_EVENTS]: fuelStationRawEvents,
	[ModulesMap.FUEL_STATION_GUNS]: fuelStationGuns,
	[ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS]: worksMaterialConsumptionRateNorms,
	[ModulesMap.WORKS_PRODUCTIVITY_NORMS]: worksProductivityNorms,
	[ModulesMap.WORKS_QUALITY_NORMS]: worksQualityNorms,
	[ModulesMap.REGULATIONS_APPLICATION_AREA]: regulationsApplicationArea,
	[ModulesMap.WORKS_STAFF_PAYMENT_RATES_NORMS]: worksStaffPaymentRatesNorms,
	[ModulesMap.CROPS]: crops,
	[ModulesMap.POSITIONS_MACHINES]: positionsMachines,
	[ModulesMap.EVENTS]: events,
	[ModulesMap.INFRASTRUCTURE_PHOTOS]: infrastructurePhotos,
	[ModulesMap.EQUIPMENT_PHOTOS]: equipmentPhotosEndpointConfig,
	[ModulesMap.REGULATIONS_METRICS]: regulationsMetricsEndpointConfig,
	[ModulesMap.REGULATIONS_STAGES]: regulationsStagesEndpointConfig,
	[ModulesMap.REGULATIONS_TARGET_PRODUCTS]: regulationsTargetProductsEndpointConfig,
	[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS]: regulationsStagesPlanWorksEndpointConfig,
	[ModulesMap.MAPS]: mapsEndpointConfig,
	[ModulesMap.BUSINESS_PROCESSES]: businessProcessesEndpointConfig,
	[ModulesMap.REGULATION_BASE_FINANCE_ATTRIBUTION]: regulationBaseFinanceAttributionEndpointConfig,
	[ModulesMap.NOTIFICATIONS]: notificationsEndpointConfig,
	[ModulesMap.REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION]: regulationPlanWorkFinanceAttributionEndpointConfig,
	[ModulesMap.REPORTS]: reportsEndpointConfig,
	[ModulesMap.REPORTS_DONE_WORKS_COSTS]: reportsDoneWorksCostsEndpointConfig,
	[ModulesMap.REPORTS_QUALITY_CONTROLS]: reportsQualityControlsEndpointConfig,
	[ModulesMap.REPORTS_DONE_WORKS]: reportsDoneWorksEndpointConfig,
	[ModulesMap.REPORTS_SERVICE_PAYMENTS]: reportsServicePaymentsEndpointConfig,
	[ModulesMap.REPORTS_STAFF_PAYMENTS]: reportsStaffPaymentsEndpointConfig,
	[ModulesMap.REPORTS_FINANCE_BY_CATEGORIES]: reportFinanceByCategoriesEndpointConfig,
	[ModulesMap.REPORTS_FINANCE_BY_DESTINATION]: reportFinanceByDestinationEndpointConfig,
	[ModulesMap.REPORTS_FINANCE_BY_WORK_TYPE]: reportFinanceByWorkTypeEndpointConfig,
	[ModulesMap.REPORTS_FINANCE_EFFICIENCY]: reportFinanceEfficiencyEndpointConfig,
	[ModulesMap.REPORTS_FINANCE_PRODUCTS]: reportFinanceProductsEndpointConfig,
	[ModulesMap.REPORTS_STAGES_PROGRESS]: reportStagesProgressEndpointConfig,
	[ModulesMap.REPORTS_STAGES_PROGRESS_WITH_WORKS]: reportStagesProgressWithWorksEndpointConfig,
	[ModulesMap.REPORTS_FINANCE_BY_MATERIALS_CATEGORIES]: reportsFinanceByMaterialsCategoriesEndpointConfig,
	[ModulesMap.REPORTS_FINANCE_BY_ROLES]: reportsFinanceByRolesEndpointConfig,
	[ModulesMap.REPORTS_FINANCE_BY_SERVICES]: reportsFinanceByServicesEndpointConfig,
	[ModulesMap.REPORTS_FINANCE_BY_WORK_CATEGORIES]: reportsFinanceByWorkCategoriesEndpointConfig,
	[ModulesMap.DONE_WORKS_BRIGADE]: doneWorksBrigadeEndpointConfig,
	[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS]: doneWorksCalculationVolumeMetricsEndpointConfig,
	[ModulesMap.DONE_WORKS_DOCUMENTS]: doneWorksDocumentsEndpointConfig,
	[ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION]: doneWorksFinanceAttributionEndpointConfig,
	[ModulesMap.DONE_WORKS_LINKS]: doneWorksLinksEndpointConfig,
	[ModulesMap.DONE_WORKS_MEASURES]: doneWorksMeasuresEndpointConfig,
	[ModulesMap.DONE_WORKS_PHOTOS]: doneWorksPhotosEndpointConfig,
	[ModulesMap.DONE_WORKS]: doneWorksEndpointConfig,
	[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_MACHINES]:
		regulationsStagesPlanWorksRecomendedMachinesEndpointConfig,
	[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_EQUIPMENT]:
		regulationsStagesPlanWorksRecomendedEquipmentEndpointConfig,
	[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_COUNTERPARTIES]:
		regulationsStagesPlanWorksRecomendedCounterpartiesEndpointConfig,
	[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_STAFF]: regulationsStagesPlanWorksRecomendedStaffEndpointConfig,
	[ModulesMap.REGULATIONS_FINANCE_PRODUCTIVITY]: regulationsFinanceProductivityEndpointConfig,
	[ModulesMap.REPORTS_REPORTING]: reportsReportingEndpointConfig,
	[ModulesMap.REGULATION_STAGE_FINANCE_ATTRIBUTION]: regulationStageFinanceAttributionEndpointConfig,
	[ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS]: doneWorksManufacturedMaterialsEndpointConfig,
	[ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS]: doneWorksOperationalMaterialsEndpointConfig,
	[ModulesMap.DONE_WORKS_SERVICES]: doneWorksServices,
	[ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS]: doneWorksCalculationMetricsMetricsEndpointConfig,
	[ModulesMap.DONE_WORKS_IN_PROGRESS_FIELD_WORKS]: doneWorksInProgressFieldWorksEndpointConfig,
	[ModulesMap.BUSINESS_PROCESSES_ACTIVE_PLAN_WORKS]: businessProcessesActivePlanWorksEndpointConfig,
	[ModulesMap.RULES_BREAKING]: rulesBreakingEndpointConfig,
	[ModulesMap.DONE_WORKS_CONTROL_METRICS]: doneWorksControlMetricEndpointConfig,
	[ModulesMap.WORK_ORDERS]: workOrdersEndpointConfig,
	[ModulesMap.WORK_ORDERS_MATERIALS]: workOrdersMaterialsEndpointConfig,
	[ModulesMap.WORK_ORDERS_PRODUCTS]: workOrdersProductsEndpointConfig,
	[ModulesMap.DONE_WORKS_DONE_FIELD_WORKS]: doneWorksDoneFieldWorksConfig,
	[ModulesMap.WEIGHING_COMBINER_TICKETS]: weighingCombinerTicketsEndpointConfig,
	[ModulesMap.DONE_WORKS_MY_WORKS_TO_ADMINISTRATE]: doneWorksMyWorksToAdministrateEndpointConfig,
	[ModulesMap.DONE_WORKS_MY_WORKS_TO_CONTROL]: doneWorksMyWorksToControlEndpointConfig,
	[ModulesMap.DONE_WORKS_MY_WORKS_TO_DO]: doneWorksMyWorksToDoEndpointConfig,
	[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS]: orderGeneratorsFieldsWorksEndpointConfig,
	[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS]: orderGeneratorsFieldsWorksPlanWorksEndpointConfig,
	[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS]: orderGeneratorsFieldsWorksQualityControlsEndpointConfig,
	[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS]: orderGeneratorsFieldsWorksProductsEndpointConfig,
	[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS]: orderGeneratorsFieldsWorksStaffPaymentsEndpointConfig,
	[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_MATERIALS]: orderGeneratorsFieldsWorksMaterialsEndpointConfig,
	[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES]:
		orderGeneratorsFieldsWorksExecutorsBrigadesEndpointConfig,
	[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS]: orderGeneratorsFieldsWorksExecutorsEndpointConfig,
	[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_SERVICES]: orderGeneratorsFieldsWorksServicesEndpointConfig,
	[ModulesMap.LOGISTIC_ROUTES]: logisticRoutesEndpointConfig,
	[ModulesMap.LOGISTIC_ROUTES_GEO_ZONES]: logisticRoutesGeoZonesEndpointConfig,
	[ModulesMap.REPORT_DEVICE_MOUNTS]: reportDeviceMountsEndpointConfig,
	[ModulesMap.DONE_WORKS_ALL_FIELD_WORKS]: doneWorksAllFieldWorksEndpointConfig,
	[ModulesMap.DONE_WORKS_ALL_LOGISTIC_WORKS]: doneWorksAllLogisticWorksEndpointConfig,
	[ModulesMap.DONE_WORKS_ALL_HAND_MADE_WORKS]: doneWorksAllHandMadeWorksEndpointConfig,
	[ModulesMap.REGULATIONS_ALL_PLAN_WORKS]: regulationsAllPlanWorksEndpointConfig,
	[ModulesMap.CARGOS]: cargosEndpointConfig,
	[ModulesMap.CARGO_ITEMS]: cargoItemsEndpointConfig,
	[ModulesMap.CARGO_TAGS]: cargoTagsEndpointConfig,
	[ModulesMap.API_USAGES]: apiUsagesEndpointConfig,
	[ModulesMap.LANDS]: landsEndpointConfig,
	[ModulesMap.EQUIPMENT_DOCUMENTS]: equipmentDocumentsEndpointConfig,
	[ModulesMap.EQUIPMENT_PLEDGES]: equipmentPledgesEndpointConfig,
	[ModulesMap.LANDS_CADASTRAL_CASES]: landsCadastralCasesEndpointConfig,
	[ModulesMap.CUSTOM_GEO_ZONES]: customGeoZonesEndpointConfig,
	[ModulesMap.CUSTOM_GEO_ZONES_CATEGORIES]: customGeoZonesCategoriesEndpointConfig,
	[ModulesMap.REGULATIONS_STAFF_ROLES_INFO]: regulationsStaffRolesInfoEndpointConfig,
	[ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS]: businessProcessBaseExecutorsEndpointConfig,
}
